/**
 * Created by Carsten Bühler
 * User: c.buehler on 17.05.2016
 * Copyright: xdot GmbH 2015
 */
import detectIE from './utils/detectIE';

import Promise from 'promise-polyfill';
if (!window.Promise) {
    window.Promise = Promise;
}

import ResizeObserver from 'resize-observer-polyfill';
if (!window.ResizeObserver) {
    window.ResizeObserver = ResizeObserver;
}

if (!Array.prototype.findIndex) {
    Array.prototype.findIndex = function (predicate) {
        if (this === null) {
            throw new TypeError('Array.prototype.findIndex called on null or undefined');
        }
        if (typeof predicate !== 'function') {
            throw new TypeError('predicate must be a function');
        }
        var list = Object(this);
        var length = list.length >>> 0;
        var thisArg = arguments[ 1 ];
        var value;

        for (var i = 0; i < length; i++) {
            value = list[ i ];
            if (predicate.call(thisArg, value, i, list)) {
                return i;
            }
        }
        return -1;
    };
}

if (!String.prototype.endsWith) {
    String.prototype.endsWith = function (searchString, position) {
        var subjectString = this.toString();
        if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
            position = subjectString.length;
        }
        position -= searchString.length;
        var lastIndex = subjectString.indexOf(searchString, position);
        return lastIndex !== -1 && lastIndex === position;
    };
}


/**
 * detect IE
 * returns version of IE or false, if browser is not Internet Explorer
 */
const ie = detectIE();
if (ie == 11) {
    console.warn('YOU ARE USING INTERNET EXPLORER 11!');
    require('core-js/fn/array/from');
    require('core-js/fn/array/find');
}

if (ie <= 10) {
    console.warn('YOU ARE USING INTERNET EXPLORER <= 10! WHY???');
    require('core-js/es6/set');
    require('core-js/es6/map');
    require('core-js/fn/array/from');
    require('core-js/fn/array/find');

    // console polyfill
    if (!window.console) {
        window.console = {};
    }
    const con = global.console;
    const dummy = function () {

    };

    const properties = [ 'memory' ];
    const methods = ('assert,clear,count,debug,dir,dirxml,error,exception,group,' +
    'groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,' +
    'show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn').split(',');

    properties.forEach(prop => {
        if (!con[ prop ]) con[ prop ] = {};
    });
    methods.forEach(m => {
        if (typeof con[ m ] !== 'function') con[ m ] = con.log;
    });

    // location.origin fix (required for websocket connection)
    if (!window.location.origin) {
        window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? (':' + window.location.port) : '');
    }

    //See FLIWAS-889 for futher infos
    Object.setPrototypeOf = function (t, e) {
        for (var n = Object.getOwnPropertyNames(e), r = 0; r < n.length; r++) {
            var o = n[ r ], i = Object.getOwnPropertyDescriptor(e, o);
            i && i.configurable && void 0 === t[ o ] && Object.defineProperty(t, o, i)
        }

        return t;
    };

}









// WEBPACK FOOTER //
// ./js/polyfills.js